<template>
  <!-- header -->
  <div class="ai-header" :class="{'active' : headerScroll}">
    <nav>
      <section class="nav-logo">
        <!-- <router-link tag="i" to="./index"><span>大数据·AI</span></router-link> -->
        <router-link tag="i" to="./index"><img :src="require('@/assets/imgs/logo.svg')" alt=""></router-link>
      </section>
      <section class="nav-menu">
        <ul class="menu-list">
          <li class="menu-item">
            <router-link to="./index"><span>首页</span></router-link>
          </li>
          <li class="menu-item menu-item-product">
            <router-link to="./index"><span>产品</span></router-link>
            <section class="menu-pannel">
              <div class="pannel-title">
                <div class="title" v-for="(item, index) in pannelTitleList" @mouseenter="setPannelActive(index)" :key="item.value" :class="{ 'title-active':index == currentPannelTitle}">{{item.label}}</div>
              </div>  
              <div class="pannel-content">
                <div class="pannel-item" v-show="0==currentPannelTitle">
                  <ul class="ai-list">
                    <li class="ai-item">
                      <div class="item-title"><span>自然语言处理</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>意图识别</span></router-link>
                        <router-link to="./index"><span>文本挖掘、分析和分类</span></router-link>
                        <router-link :to="{name:'feature'}" target="_blank" class="existing"><span>特征抽取</span></router-link>
                        <router-link to="./index"><span>文本自动打标签</span></router-link>
                        <router-link to="./index"><span>实体识别</span></router-link>
                        <router-link to="./index"><span>句向量服务</span></router-link>
                      </div>
                    </li>
                    <li class="ai-item">
                      <div class="item-title"><span>图像识别</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>证件识别</span></router-link>
                        <a @click="gotoProductDetail('face')" class="existing"><span>人脸识别</span></a>
                        <router-link to="./index"><span>场景识别</span></router-link>
                      </div>
                    </li>
                    <li class="ai-item">
                      <div class="item-title"><span>语音识别</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>声纹检测</span></router-link>
                        <router-link to="./index"><span>人声识别</span></router-link>
                        <a @click="gotoProductDetail('speak')" class="existing"><span>语速检测</span></a>
                        <router-link to="./index"><span>情绪检测</span></router-link>
                        <router-link to="./index"><span>中文TTS</span></router-link>
                        <router-link to="./index"><span>印尼语音识别</span></router-link>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="pannel-item" v-show="1==currentPannelTitle">
                  <ul class="ai-list">
                    <li class="ai-item">
                      <div class="item-title"><span>基础架构</span></div>
                      <div class="item-content">
                        <a @click="gotoProductDetail('das')" class="existing"><span>DAS数据库访问框架</span></a>
                        <router-link to="./index"><span>PMQ消息中间件</span></router-link>
                        <a @click="gotoProductDetail('cloud')" class="existing"><span>Stargate容器云管理平台</span></a>
                        <router-link to="./index"><span>星云多环境系统</span></router-link>
                        <router-link to="./index"><span>谛听全链路监控平台</span></router-link>
                      </div>
                    </li>
                    <li class="ai-item">
                      <div class="item-title"><span>研发效能</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>数据库自动化运维</span></router-link>
                        <router-link to="./index"><span>数据库统一查询平台</span></router-link>
                        <router-link to="./index"><span>代码扫描平台</span></router-link>
                        <router-link to="./index"><span>分支管理平台</span></router-link>
                        <router-link to="./index"><span>持续集成平台</span></router-link>
                        <router-link to="./index"><span>自动化测试平台</span></router-link>
                        <router-link to="./index"><span>研发效能平台</span></router-link>
                      </div>
                    </li>
                    <li class="ai-item">
                      <div class="item-title"><span>业务中台</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>PMS营销系统</span></router-link>
                        <router-link to="./index"><span>魔方</span></router-link>
                      </div>
                    </li>
                    <li class="ai-item">
                      <div class="item-title"><span>移动中台</span></div>
                      <div class="item-content">
                        <router-link to="./index"><span>神庙渠道管理平台</span></router-link>
                        <router-link to="./index"><span>智能投放平台</span></router-link>
                        <router-link to="./index"><span>LC发控平台</span></router-link>
                        <router-link to="./index"><span>消息推送平台</span></router-link>
                        <router-link to="./index"><span>神笔活动平台</span></router-link>
                        <router-link to="./index"><span>CMS资讯平台</span></router-link>
                        <router-link to="./index"><span>用户权益平台</span></router-link>
                        <router-link to="./index"><span>XMace</span></router-link>
                        <router-link to="./index"><span>LdPaaS开发平台</span></router-link>
                        <router-link to="./index"><span>Maltose开发平台</span></router-link>
                        <router-link to="./index"><span>Vax多端开发平台</span></router-link>
                        <router-link to="./index"><span>移动测试平台</span></router-link>
                        <router-link to="./index"><span>数据港用户行为分析平台</span></router-link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section> 
          </li>
          <li class="menu-item">
            <router-link to="./index"><span>解决方案</span></router-link>
          </li>
          <li class="menu-item">
            <router-link to="./index"><span>信也科技杯</span></router-link>
          </li>
          <li class="menu-item">
            <router-link to="./index"><span>合作与社区</span></router-link>
          </li>
        </ul>
      </section>
      <section class="nav-right">
        <router-link to="./index"><span>登录</span></router-link>
        <router-link to="./index"><span>注册</span></router-link>
      </section>
    </nav>
  </div>
</template>
<script charset="utf-8">
import { reactive, onMounted, toRefs, nextTick, watch } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Header',
  components: {
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      headerScroll: false,
      currentPannelTitle: 0,
      pannelTitleList:[
        { key:'product', value: 'product', label: 'AI产品' },
        { key:'dev', value: 'dev', label: '研发运维产品' },
      ],
    });
    nextTick(() => {
      window.addEventListener('scroll', () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        scrollTop > 60 ? state.headerScroll = true : state.headerScroll = false
      })
    })
    watch('$route', (newVal, oldVal) => {
        console.log(newVal)
        console.log(oldVal)
      }
    )
    const setPannelActive = (idx) => {
      state.currentPannelTitle = idx;
    }
    const refresh = ()=>{
      router.go(0);  
    }
    const gotoProductDetail = (name) =>{
      let routeData = router.resolve({name, query: {}});
      window.open(routeData.href, '_blank');
    }
    return {
      ...toRefs(state),
      setPannelActive,
      refresh,
      gotoProductDetail,
    };
  }
}
</script>
<style scoped lang="scss">
  .ai-header{
    position: fixed;
    top: 0;
    width: 100%;
    border: 0;
    z-index: 2;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
    &.active {
      background: #00172b;
    }
    nav{
      position: relative;
      width: 1182px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .nav-logo,.nav-right{
        flex-shrink: 0;
      }
      .nav-logo{
        width: 185px;
        span{
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          line-height: 16px;
        }
        img{
          width: 72px;
        }
      }
      .nav-menu{
        position: relative;
        flex: 1;
        .menu-list{
          font-size: 14px;
          display: flex;
          align-items: center;
          .menu-item{
            position: relative;
            margin-right: 53px;
            &:last-child{
              margin-right: 0;
            }
            & > a{
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #FFFFFF;
              letter-spacing: 0;
              padding: 20px 0;
            }
            .menu-pannel{
              position: absolute;
              top: 39px;
              left: -200px;
              width: 972px;
              height: 490px;
              background: #FFFFFF;
              -webkit-box-shadow: 0 10px 20px 0 rgba(0,0,0,.06);
              box-shadow: 0 10px 20px 0 rgba(0,0,0,.06);
              opacity: 0;
              visibility: hidden;
              -webkit-transition: opacity .2s;
              -moz-transition: opacity .2s;
              transition: opacity .2s;
              z-index: 10;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              border-radius: 4px;
              .pannel-title{
                width: 140px;
                margin: 30px 60px 72px 0;
                border-right: 1px solid #E9EDFA;
                flex-shrink: 0;
                .title{
                  cursor: pointer;
                  text-align: left;
                  height: 35px;
                  line-height: 35px;
                  font-size: 14px;
                  padding-left: 30px;
                  margin-bottom: 6px;
                  cursor: pointer;
                  font-family: PingFangSC-Medium;
                  color: #35426C;
                  &:hover{
                    background: #35426C;
                    color: #FFFFFF;
                  }
                }
                .title-active{
                  background: #35426C;
                  color: #FFFFFF;
                }
              }
              .pannel-content{
                padding: 42px 0 0;
                &::before{
                  content: '';
                  display: inline-block;
                  position: absolute;
                  border-top: 18px solid transparent;
                  border-bottom: 18px solid transparent;
                  border-left: 18px solid #fff;
                  left: 212px;
                  -webkit-transform: translate(-50%,0) rotate(-90deg);
                  -ms-transform: translate(-50%,0) rotate(-90deg);
                  transform: translate(-50%,0) rotate(-90deg);
                  top: -18px;
                }
                .ai-list{
                  display: -webkit-box;
                  display: -ms-flexbox;
                  display: flex;
                  -ms-flex-wrap: wrap;
                  flex-wrap: wrap;
                  -webkit-box-flex: 1;
                  -ms-flex: 1;
                  flex: 1;
                  .ai-item{
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    width: 140px;
                    margin-right: 60px;
                    height: -webkit-max-content;
                    height: -moz-max-content;
                    height: max-content;
                    &:last-child{
                      margin-right: 0;
                    }
                    &:nth-child(4n){
                      margin: 0;
                    }
                    .item-title{
                      cursor: pointer;
                      text-align: left;
                      border-bottom: 1px solid #E9EDFA;
                      padding-bottom: 9px;
                      margin-bottom: 20px;
                      font-family: PingFangSC-Medium;
                      font-size: 14px;
                      color: #35426C;
                      line-height: 14px;
                      display: -webkit-box;
                      display: -ms-flexbox;
                      display: flex;
                      -webkit-box-align: center;
                      -ms-flex-align: center;
                      align-items: center;
                    }
                    .item-content{
                      display: -webkit-box;
                      display: -ms-flexbox;
                      display: flex;
                      -webkit-box-orient: vertical;
                      -webkit-box-direction: normal;
                      -ms-flex-direction: column;
                      flex-direction: column;
                      text-align: left;
                      & > a{
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #727991;
                        line-height: 14px;
                        margin-bottom: 16px;
                        cursor: pointer;
                        white-space: nowrap;
                      }
                      .existing{
                        &:hover{
                          color: #467CFD;
                        }
                      }
                    }
                  }
                }
              }
            }
            .menu-pannel-active{
              height: auto;
              padding: 26px 20px 6px 0;
            }
          }
          .menu-item-product{
            &:hover{
              .menu-pannel{
                opacity: 1;
                visibility: visible;
              }
            }
          }
        }
      }
      .nav-right{
        width: 80px;
        white-space: nowrap;
        span{
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 14px;
        }
        &{
          a:first-child{
            margin-right: 24px;
          }
        }
      }
    }
  }
</style>
